import React from 'react';
import { Spinner } from 'ui';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const ElementLoading = ({ isLoading = false, text, children }) => {
  if (isLoading) {
    return (
      <div className="ElementLoading">
        <div className="ElementLoading-row">
          <Spinner className="ElementLoading-row--Spinner" size="larger" />
          {text && <Text variant={TEXT_VARIANTS.BODY_LIGHT}>{text}</Text>}
        </div>
      </div>
    );
  }
  return children;
};

export default ElementLoading;
